<template>
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_310_12018)">
            <path
                d="M14.1922 2.80856C12.9844 1.60082 11.6943 2.38251 10.8869 3.1899L3.2598 10.8172C2.45242 11.6246 1.60734 12.8512 2.87847 14.1222C4.14959 15.3936 5.37625 14.5483 6.18349 13.7409L13.8108 6.11376C14.6181 5.30628 15.3998 4.01613 14.1922 2.80856Z"
                fill="#FF7370"
            />
            <path
                d="M6.90543 2.49628L8.52048 4.11123L10.1644 2.46733C10.276 2.35546 10.3893 2.25165 10.5033 2.15375C10.3311 1.2852 9.83556 0.5 8.51968 0.5C7.20138 0.5 6.70638 1.28829 6.53516 2.15872C6.65823 2.26519 6.78107 2.37191 6.90543 2.49628Z"
                fill="#FF7370"
            />
            <path
                d="M10.1631 14.4925L8.52025 12.8496L6.90605 14.4636C6.78349 14.5863 6.66151 14.6983 6.54004 14.8036C6.72513 15.689 7.24901 16.5 8.51954 16.5C9.79339 16.5 10.3166 15.6846 10.5005 14.7964C10.3875 14.6992 10.2744 14.6038 10.1631 14.4925Z"
                fill="#FF7370"
            />
            <path
                d="M6.22033 6.41138H3.10675C1.96514 6.41138 0.5 6.77105 0.5 8.47883C0.5 9.75315 1.31561 10.2764 2.20403 10.4602C2.30921 10.3388 6.22033 6.41138 6.22033 6.41138Z"
                fill="#FF7370"
            />
            <path
                d="M14.8416 6.49438C14.7431 6.60899 10.8237 10.5463 10.8237 10.5463H13.8931C15.0348 10.5463 16.4998 10.2765 16.4998 8.47891C16.4998 7.16075 15.7118 6.66551 14.8416 6.49438Z"
                fill="#FF7370"
            />
            <path
                d="M7.24073 5.38926L7.79694 4.83303L6.18293 3.21877C5.37549 2.41146 4.14898 1.5663 2.87785 2.83743C1.94575 3.76953 2.15278 4.67671 2.64718 5.41316C2.79776 5.40204 7.24073 5.38926 7.24073 5.38926Z"
                fill="#FF7370"
            />
            <path
                d="M9.79992 11.5683L9.24219 12.126L10.8863 13.7699C11.6937 14.5774 12.9838 15.3589 14.1914 14.1513C15.0925 13.2501 14.8857 12.3036 14.3875 11.5454C14.2272 11.557 9.79992 11.5683 9.79992 11.5683Z"
                fill="#FF7370"
            />
        </g>
        <defs>
            <clipPath id="clip0_310_12018">
                <rect width="16" height="16" fill="var(--joy-color-neutral-0)" transform="translate(0.5 0.5)" />
            </clipPath>
        </defs>
    </svg>
</template>
